export const getButtonText = courseLearningProgress => {
  if (courseLearningProgress === 1) {
    return 'review';
  }
  if (courseLearningProgress === 0) {
    return 'start';
  }
  return 'continue';
};

export const getLineProgressBarText = ({
  courseLearningProgress,
  t,
  duration,
  remainingDurationMinute,
}) => {
  if (courseLearningProgress === 1) {
    return t('videoplayer.watch.completeTag');
  }
  if (courseLearningProgress === 0) {
    return duration;
  }
  return t('videoplayer.progressRemaining', {
    minute: remainingDurationMinute,
  });
};
